<label *ngIf="label" class="ppl-label">{{label}}</label>
<ng-content></ng-content>
